import React from 'react';

import { PinFlowScreen } from '../../components/common/PinFlowScreen';
import { useFirmwareContext } from '../../contexts/FirmwareContext';

export const DisablePinScreen: React.FC = () => {
  const { baseStationConfig } = useFirmwareContext();

  const currentPin = baseStationConfig?.lock_pin ? baseStationConfig.lock_pin.split('') : undefined;
  return (
    <PinFlowScreen
      type="disable"
      titleKey="settings.lockScreen.disablePin"
      currentPin={currentPin}
    />
  );
};
